import React, { useEffect, useState } from "react";
import Body from "components/Body";
import useTranslation from "next-translate/useTranslation";
import Cookies from "universal-cookie";
import { XIcon } from "@heroicons/react/outline";

export default function FlashInfo({ node, visibilityHandler }) {
  const { t } = useTranslation("common");
  const [show, setShow] = useState(false);
  const cookies = new Cookies();

  const discard = () => {
    const closedId = cookies.get("flash-closed");

    if (show && (closedId === undefined || closedId !== node.id)) {
      cookies.set("flash-closed", node.id, { path: "/" });
    }

    setShow(false);
  };

  useEffect(() => {
    const closedId = cookies.get("flash-closed");

    if (closedId !== node.id) {
      setShow(true);
    }
  }, [setShow]);

  useEffect(() => {
    visibilityHandler(show);
  }, [show]);

  return show ? (
    <div className="relative bg-primary text-white py-4 border-b overflow-hidden z-30">
      <div className="container mx-auto px-4">
        <div className="flex flex-col lg:flex-row lg:items-top gap-4 lg:gap-8">
          <div className="flex-1 prose prose-white max-w-none">
            <Body value={node.body?.processed} />
          </div>
          <div className="flex-initial">
            <button type="button" onClick={() => discard()}>
              <XIcon className="h-6 w-6" aria-hidden="true" />
              <span className="sr-only">{t("utils.close")}</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  ) : null;
}
